// loyalty — see README.md. Keys must exist in BOTH maps (checked by npm run check:locales).
export const en = {
  'loyalty.title': 'Loyalty & Rewards',
  'loyalty.manager': 'Loyalty Manager',
  'loyalty.members': 'Members',
  'loyalty.rewards': 'Rewards Catalogue',
  'loyalty.giftCards': 'Gift Cards',
  'loyalty.settings': 'Programme Settings',

  // Dashboard
  'loyalty.dash.membersCount': 'Members',
  'loyalty.dash.new30d': 'New in 30 days',
  'loyalty.dash.pointsOut': 'Points outstanding',
  'loyalty.dash.memberSpend': 'Member spend',
  'loyalty.dash.vouchersActive': 'Vouchers live',
  'loyalty.dash.giftLiability': 'Gift card liability',
  'loyalty.dash.pendingLeads': 'Sign-ups waiting',
  'loyalty.dash.tierSplit': 'Members by tier',
  'loyalty.dash.topMembers': 'Top members',
  'loyalty.dash.programOff': 'The programme is switched off — guests are not earning. Turn it on in Programme Settings.',
  'loyalty.dash.earned': 'Earned',
  'loyalty.dash.redeemed': 'Redeemed',
  'loyalty.dash.expired': 'Expired',

  // Members / lookup
  'loyalty.search.placeholder': 'Phone, name or membership number…',
  'loyalty.search.action': 'Search',
  'loyalty.enrol.action': 'Enrol a guest',
  'loyalty.enrol.title': 'Enrol a guest',
  'loyalty.enrol.hint': 'The phone number is the guest’s key — if they already exist, the membership lands on their record.',
  'loyalty.member.balance': 'Balance',
  'loyalty.member.lifetime': 'Lifetime',
  'loyalty.member.visits': 'Visits',
  'loyalty.member.spend': 'Spend',
  'loyalty.member.tier': 'Tier',
  'loyalty.member.since': 'Member since',
  'loyalty.member.noTier': 'No tier',
  'loyalty.member.expiring': '{points} points lapse on {date}',
  'loyalty.member.adjust': 'Adjust points',
  'loyalty.member.adjustReason': 'Why? (required — it goes on the ledger)',
  'loyalty.member.suspend': 'Suspend',
  'loyalty.member.reinstate': 'Reinstate',
  'loyalty.member.ledger': 'Points ledger',
  'loyalty.member.vouchers': 'Vouchers',
  'loyalty.member.claim': 'Claim a reward',
  'loyalty.leads.title': 'Self-service sign-ups',
  'loyalty.leads.convert': 'Make member',
  'loyalty.leads.discard': 'Discard',
  'loyalty.leads.empty': 'No sign-ups waiting.',

  // Catalogue
  'loyalty.reward.add': 'Add a reward',
  'loyalty.reward.edit': 'Edit reward',
  'loyalty.reward.cost': 'Points',
  'loyalty.reward.kind.FREE_DISH': 'Free dish',
  'loyalty.reward.kind.PERCENT_OFF': '% off the bill',
  'loyalty.reward.kind.AMOUNT_OFF': 'Amount off',
  'loyalty.reward.kind.EXPERIENCE': 'Experience',
  'loyalty.reward.retired': 'Retired',
  'loyalty.reward.stock': 'Stock',
  'loyalty.reward.claimed': 'claimed',

  // Vouchers
  'loyalty.voucher.code': 'Voucher code',
  'loyalty.voucher.redeem': 'Redeem voucher',
  'loyalty.voucher.void': 'Void',
  'loyalty.voucher.status.ACTIVE': 'Ready to use',
  'loyalty.voucher.status.REDEEMED': 'Used',
  'loyalty.voucher.status.EXPIRED': 'Expired',
  'loyalty.voucher.status.VOID': 'Cancelled',

  // Gift cards
  'loyalty.gc.sell': 'Sell a gift card',
  'loyalty.gc.lookup': 'Look up a card',
  'loyalty.gc.liability': 'Outstanding on active cards',
  'loyalty.gc.redeem': 'Spend from card',
  'loyalty.gc.topup': 'Top up',
  'loyalty.gc.void': 'Void card',
  'loyalty.gc.voidWarn': 'This retires money the guest paid for. Sure?',
  'loyalty.gc.status.ACTIVE': 'Active',
  'loyalty.gc.status.REDEEMED': 'Fully spent',
  'loyalty.gc.status.EXPIRED': 'Expired',
  'loyalty.gc.status.VOID': 'Cancelled',
  'loyalty.gc.status.INACTIVE': 'Not activated',

  // Settings
  'loyalty.set.enable': 'Programme is on',
  'loyalty.set.earning': 'Earning',
  'loyalty.set.redeeming': 'Redeeming',
  'loyalty.set.expiry': 'Expiry',
  'loyalty.set.bonuses': 'Bonuses',
  'loyalty.set.enrolment': 'Enrolment',
  'loyalty.set.tiers': 'Tiers',
  'loyalty.set.rules': 'Bonus earn rules',
  'loyalty.set.addTier': 'Add tier',
  'loyalty.set.addRule': 'Add rule',
  'loyalty.set.save': 'Save programme',
  'loyalty.set.saved': 'Programme saved.',

  // Shared
  'loyalty.common.name': 'Name',
  'loyalty.common.phone': 'Phone',
  'loyalty.common.status': 'Status',
  'loyalty.common.when': 'When',
  'loyalty.common.actions': 'Actions',
  'loyalty.common.save': 'Save',
  'loyalty.common.cancel': 'Cancel',
  'loyalty.common.yes': 'Yes',
  'loyalty.common.loading': 'Loading…',
  'loyalty.common.none': 'Nothing here yet.',
};

export const fr = {
  'loyalty.title': 'Fidélité & Récompenses',
  'loyalty.manager': 'Gestion fidélité',
  'loyalty.members': 'Membres',
  'loyalty.rewards': 'Catalogue de récompenses',
  'loyalty.giftCards': 'Cartes cadeaux',
  'loyalty.settings': 'Paramètres du programme',

  'loyalty.dash.membersCount': 'Membres',
  'loyalty.dash.new30d': 'Nouveaux en 30 jours',
  'loyalty.dash.pointsOut': 'Points en circulation',
  'loyalty.dash.memberSpend': 'Dépenses des membres',
  'loyalty.dash.vouchersActive': 'Bons actifs',
  'loyalty.dash.giftLiability': 'Encours cartes cadeaux',
  'loyalty.dash.pendingLeads': 'Inscriptions en attente',
  'loyalty.dash.tierSplit': 'Membres par niveau',
  'loyalty.dash.topMembers': 'Meilleurs membres',
  'loyalty.dash.programOff': 'Le programme est désactivé — les clients ne cumulent pas de points. Activez-le dans les Paramètres du programme.',
  'loyalty.dash.earned': 'Cumulés',
  'loyalty.dash.redeemed': 'Utilisés',
  'loyalty.dash.expired': 'Expirés',

  'loyalty.search.placeholder': 'Téléphone, nom ou numéro de membre…',
  'loyalty.search.action': 'Rechercher',
  'loyalty.enrol.action': 'Inscrire un client',
  'loyalty.enrol.title': 'Inscrire un client',
  'loyalty.enrol.hint': 'Le numéro de téléphone est la clé du client — s’il existe déjà, l’adhésion rejoint sa fiche.',
  'loyalty.member.balance': 'Solde',
  'loyalty.member.lifetime': 'Cumul total',
  'loyalty.member.visits': 'Visites',
  'loyalty.member.spend': 'Dépenses',
  'loyalty.member.tier': 'Niveau',
  'loyalty.member.since': 'Membre depuis',
  'loyalty.member.noTier': 'Sans niveau',
  'loyalty.member.expiring': '{points} points expirent le {date}',
  'loyalty.member.adjust': 'Ajuster les points',
  'loyalty.member.adjustReason': 'Pourquoi ? (obligatoire — inscrit au registre)',
  'loyalty.member.suspend': 'Suspendre',
  'loyalty.member.reinstate': 'Réactiver',
  'loyalty.member.ledger': 'Registre des points',
  'loyalty.member.vouchers': 'Bons',
  'loyalty.member.claim': 'Échanger une récompense',
  'loyalty.leads.title': 'Inscriptions en libre-service',
  'loyalty.leads.convert': 'Créer le membre',
  'loyalty.leads.discard': 'Écarter',
  'loyalty.leads.empty': 'Aucune inscription en attente.',

  'loyalty.reward.add': 'Ajouter une récompense',
  'loyalty.reward.edit': 'Modifier la récompense',
  'loyalty.reward.cost': 'Points',
  'loyalty.reward.kind.FREE_DISH': 'Plat offert',
  'loyalty.reward.kind.PERCENT_OFF': '% sur l’addition',
  'loyalty.reward.kind.AMOUNT_OFF': 'Montant déduit',
  'loyalty.reward.kind.EXPERIENCE': 'Expérience',
  'loyalty.reward.retired': 'Retirée',
  'loyalty.reward.stock': 'Stock',
  'loyalty.reward.claimed': 'échangées',

  'loyalty.voucher.code': 'Code du bon',
  'loyalty.voucher.redeem': 'Utiliser le bon',
  'loyalty.voucher.void': 'Annuler',
  'loyalty.voucher.status.ACTIVE': 'Prêt à l’emploi',
  'loyalty.voucher.status.REDEEMED': 'Utilisé',
  'loyalty.voucher.status.EXPIRED': 'Expiré',
  'loyalty.voucher.status.VOID': 'Annulé',

  'loyalty.gc.sell': 'Vendre une carte cadeau',
  'loyalty.gc.lookup': 'Consulter une carte',
  'loyalty.gc.liability': 'Encours des cartes actives',
  'loyalty.gc.redeem': 'Dépenser depuis la carte',
  'loyalty.gc.topup': 'Recharger',
  'loyalty.gc.void': 'Annuler la carte',
  'loyalty.gc.voidWarn': 'Ceci retire de l’argent payé par le client. Confirmer ?',
  'loyalty.gc.status.ACTIVE': 'Active',
  'loyalty.gc.status.REDEEMED': 'Épuisée',
  'loyalty.gc.status.EXPIRED': 'Expirée',
  'loyalty.gc.status.VOID': 'Annulée',
  'loyalty.gc.status.INACTIVE': 'Non activée',

  'loyalty.set.enable': 'Programme actif',
  'loyalty.set.earning': 'Cumul',
  'loyalty.set.redeeming': 'Utilisation',
  'loyalty.set.expiry': 'Expiration',
  'loyalty.set.bonuses': 'Bonus',
  'loyalty.set.enrolment': 'Adhésion',
  'loyalty.set.tiers': 'Niveaux',
  'loyalty.set.rules': 'Règles de cumul bonus',
  'loyalty.set.addTier': 'Ajouter un niveau',
  'loyalty.set.addRule': 'Ajouter une règle',
  'loyalty.set.save': 'Enregistrer le programme',
  'loyalty.set.saved': 'Programme enregistré.',

  'loyalty.common.name': 'Nom',
  'loyalty.common.phone': 'Téléphone',
  'loyalty.common.status': 'Statut',
  'loyalty.common.when': 'Date',
  'loyalty.common.actions': 'Actions',
  'loyalty.common.save': 'Enregistrer',
  'loyalty.common.cancel': 'Annuler',
  'loyalty.common.yes': 'Oui',
  'loyalty.common.loading': 'Chargement…',
  'loyalty.common.none': 'Rien pour le moment.',
};
